import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturesAndMission.css';

const FeaturesAndMission = () => {
  const features = [
    {
      icon: "❖",
      title: "High quality products",
      desc: "Our project management solutions ensure that every deliverable meets international standards of excellence."
    },
    {
      icon: "✱",
      title: "Professional services",
      desc: "Our devoted consultants offer over 25 years of multidisciplinary experience to fill project gaps effectively."
    },
    {
      icon: "✖",
      title: "Real partnership",
      desc: "We act as a single point of contact, building long-term value for stakeholders and communities alike."
    }
  ];

  return (
    <section className="features-mission-container">
      {/* Top Cards Section */}
      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="card-inner">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-text">{feature.desc}</p>
            </div>
            <div className="card-hover-overlay"></div>
          </div>
        ))}
      </div>

      {/* Mission Section */}
      <div className="mission-content">
        <h2 className="mission-headline">Who we are</h2>
        
        <p className="who-we-are-description">
          MTPRO is a group of consultants with more than 25 years of experience in different fields of engineering. We are sharing the same vision to create a pool of professionals to help companies and stakeholders fill gaps in any phase of medium to enterprise projects.
        </p>

        <Link to="/about#whoWeAre" className="btn-click-here">Click here</Link>
      </div>
    </section>
  );
};

export default FeaturesAndMission;
